import { useState } from "react"

export const VariableSuppliers = () => {
    const [state, setState] = useState({
        material_id: "",
        material_name: "",
        company_project_id: "",
        company_project_name: "",
        supplier_id: "",
        supplier_name: "",
        qty: '',
        cost: '',
        currency: "",
        date_of_supply: "",
        time_of_supply: "",
        place_of_supply: "",
        reason_of_supply: "",
        open: false,
        openEdit: false,
        arr1: [],
        Load: false,
        startDate: "",
        endDate: ""
    })
    const setStateCustom = (variableName, value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            [variableName]: value,
        }));
    };
    const setLoad = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            Load: value,
        }));
    };
    const setOpen = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            open: value,
        }));
    };
    const setopenEdit = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            openEdit: value,
        }));
    };
    const handleEdit = (event, arr) => {
        event.preventDefault();
        setState((prevState) => ({
            ...prevState,
            arr1: arr,
            openEdit: true
        }));
    }
    const handleChangeDate = (range) => {
        const [startDatee, endDatee] = range;
        setState((prevState) => ({
            ...prevState,
            startDate: startDatee,
            endDate: endDatee
        }));
    };
    return {
        ...state,
        state,
        setState,
        handleEdit,
        setOpen,
        setopenEdit,
        setStateCustom,
        setLoad,handleChangeDate
    }
}
